import React, { useState } from "react";
import Link from "helpers/link";
import getButtonStyle from "helpers/get-button-style";
import getWidth from "helpers/get-width";
import { customBgColor } from "utils/module-settings";

const ButtonsGrid = ({ data: { title, rowSize, buttons, style, isExpandable, initial, moduleSettings } }) => {
    const [isOpen, setIsOpen] = useState(!isExpandable);

    return (
        <div className="mx-auto container">
            <div className="bg-white">
                <div className={`relative p-0 sm:p-3 transition-all duration-500 ease-in-out rounded-sm ${isExpandable ? `${isOpen ? "pb-3" : "!pb-10"} shadow-gray border border-neutral-200` : ""}`} style={{ background: `${customBgColor(moduleSettings?.bgColor)}` }}>
                    {title && (
                        <h4 className="text-gray-701 text-h4 mb-4 text-center">
                            {title}
                        </h4>
                    )}
                    <div className="flex flex-wrap justify-start">
                        {buttons.map((button, index) => (
                        // eslint-disable-next-line no-nested-ternary
                            <div key={button?._key} className={`w-full transition-all duration-500 ease-in-out md:w-1/2 ${getWidth(rowSize)} ${index > initial - 1 ? isOpen ? "max-h-[30rem] sm:px-2 py-1.5" : "p-0 opacity-0 max-h-0" : "sm:px-2 py-1.5"}`}>
                                <Link className={`${getButtonStyle(style)} py-3 mb-1 max-w-full md:px-6 text-xs sm:text-base-xs border-0 text-center h-full items-center font-bold`} to={button?.url} key={button?._key}>
                                    {button?.title}
                                </Link>
                            </div>
                        ))}
                    </div>
                    {isExpandable && (
                        <div className={`absolute w-full -bottom-4 left-0 transition-opacity duration-500 ease-in-out flex justify-center ${isOpen ? "opacity-0" : ""}`}>
                            <button 
                                type="button"
                                className="transition-[background] duration-300 ease-in-out font-bold rounded-sm md:text-base text-base-xs bg-[#646a63] text-white md:px-12 md:py-2 px-9 py-1.5 hover:bg-[#303030]"
                                onClick={() => setIsOpen((prevState) => !prevState)}
                                onKeyDown={() => setIsOpen((prevState) => !prevState)}
                            >
                                See More

                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    ); 
};

export default ButtonsGrid;
